<template>
	<CHeaderLayout @show-account-menu="$emit('show-account-menu')">
		<template #title>
			<h1>Appearance</h1>
		</template>

		<main class="organization-appearance">
			<COrganizationAppearanceView />
		</main>
	</CHeaderLayout>
</template>
<script lang="ts">
	import { defineComponent } from 'vue';
	import CHeaderLayout from 'src/components/app/HeaderLayout.vue';
	import COrganizationAppearanceView from './OrganizationAppearanceView.vue';

	export default defineComponent({
		components: { COrganizationAppearanceView, CHeaderLayout },
		emits: ['show-account-menu'],
		head() {
			return {
				title: 'Appearance - Cognito Forms',
				titleTemplate: '%s'
			};
		}
	});
</script>